/** Client de `GET /api/premiers-pas/etat` (C21 SP4, 4.2 ; C24 SP3, palier 2) — les huit faits de la liste « Premiers pas ». */

export interface PremiersPasRetours { noteId: string; title: string; modifiee: boolean }

export interface PremiersPasEtat {
  document: boolean;
  citation: boolean;
  concept: boolean;
  assistant: boolean;
  partage: boolean;
  retours: PremiersPasRetours | null;
  /** Palier 2 (C24 SP3) : un passage d'une note hors exemple relié à une autre note. */
  noteReliee: boolean;
  /** Palier 2 (C24 SP3) : ce qu'un contact entend par un mot a été lu. */
  definitionLue: boolean;
  /** Un contact a partagé une note ou un dossier : la ligne 8 mène aux Actualités. */
  partageRecu: boolean;
}

export async function fetchPremiersPasEtat(token: string): Promise<PremiersPasEtat> {
  const response = await fetch('/api/premiers-pas/etat', {
    headers: { Authorization: `Bearer ${token}`, accesstoken: token, 'Content-Type': 'application/json' },
  });
  if (!response.ok) throw new Error(`premiers-pas/etat : erreur ${response.status}`);
  const body = (await response.json()) as { success: boolean; etat: PremiersPasEtat };
  return body.etat;
}
